import { useContext } from "react";

import CallContext from "src/contexts/CallContext";

const useCall = () => useContext(CallContext);

export default useCall;
